

import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Loading from 'vux/src/components/loading/index.vue'


export default {
components: {
Group,
CellBox,
Flexbox,
FlexboxItem,
XButton,
XTable,
Timeline,
TimelineItem,
Tabbar,
TabbarItem,
Loading
},
data(){
return{
records:[]
}
},
mounted(){


this.$vux.loading.show({
text: 'Loading'
})

var token = localStorage.getItem("accessToken");
this.$api.StudyRecord("",token)
.then((data)=>{
if(data.data.Status!=0){
return ;
}
var json = data.data.Data.rows;
this.records = json;
})


setTimeout(() => {
this.$vux.loading.hide()
}, 1000)
},
methods:{
getSortedList:function(list,categoryType){
return list.filter( item => item.LogType == categoryType );
},

toDetails:function(type){

var url = event.target.id;

if(type == "ReadCourse" || type == "StoreCourse" || type=="Answer"){
var courseId = url.substring((url.lastIndexOf("/")+1),url.length).toUpperCase();
this.$router.push({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: courseId,
level1: "学习记录",
}
})
}
if(type == "ReadVideo" || type == "StoreVideo"){
var courseUrl = url.substring(0,url.lastIndexOf("/")).toUpperCase();
var courseId = courseUrl.substring(courseUrl.lastIndexOf("/")+1,courseUrl.length);

var chapterId = url.substring((url.lastIndexOf("/")+1),url.length);

this.$router.push({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: courseId,
ChapterID:chapterId,
level1: "学习记录",
}
});
}

}

}
}





// WEBPACK FOOTER //
// ./src/views/Personal/StudyRecord.vue